import React from 'react'
import FilterComponent from './FilterComponent'

const index = () => {
  return (
    <div>
      <h4 className='text-xl py-6 px-3'>Filtre</h4>
      <div> 
        <FilterComponent />
      </div>
    </div>
  )
}

export default index
